import { combineReducers } from 'redux';

import {
  LOAD_SONG_TIMELINE,
  UNLOAD_CURRENT_ARTIST,
  CLEAR_SONG_TIMELINE,
} from '../../actionTypes';
import { loadReducer } from '../helpers';

export const timeline = combineReducers({
  data(state = null, action) {
    switch (action.type) {
      case UNLOAD_CURRENT_ARTIST:
      case CLEAR_SONG_TIMELINE:
        return null;
      case LOAD_SONG_TIMELINE:
        return loadReducer(state, action);
      default:
        return state;
    }
  },

  query(state = null, action) {
    switch (action.type) {
      case UNLOAD_CURRENT_ARTIST:
      case CLEAR_SONG_TIMELINE:
        return null;
      case LOAD_SONG_TIMELINE: {
        if (action.meta.request) return action.meta.query;
        return state;
      }
      default:
        return state;
    }
  },
});
